import styled, { css } from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import { getDirection } from "../../../../../../../../common-deprecated/themes/common";
import * as CashPrice from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/price/CashPrice";
import * as MonthlyPrice from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/price/MonthlyPrice";
import { lineClampStyle } from "../../../../../../../../common-deprecated/styles/v2/toyota/utilities/LineClamp";

export const Header = styled.div`
    display: flex;
    position: relative;
    flex: 1;
    flex-direction: column;
    width: 100%;
    padding: ${theme.space[2]}px ${theme.space[3]}px;
    cursor: pointer;

    ${CashPrice.Text}, ${MonthlyPrice.Text} {
        font-family: ${theme.fonts.base};
    }

    ${Button.Checkbox} {
        margin-top: auto;
        margin-${getDirection("left")}: auto;
    }
`;

export const ImageWrapper = styled.div`
    position: relative;
    flex-shrink: 0;
    width: 100%;
    border-radius: 4px 4px 0 0;
    cursor: pointer;
    img {
        width: 100%;
        height: auto;
    }
`;

export const HeaderTop = styled.h4`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
`;

export const Footer = styled.div<{ darkVariant?: boolean }>`
    display: flex;
    align-items: center;
    column-gap: ${theme.space[2]}px;
    width: 100%;
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    line-height: 2.4rem;
    background-color: ${({ darkVariant }) => (darkVariant ? theme.colors.grey1 : theme.colors.primaryWhite)};
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    cursor: pointer;

    &:not(:empty) {
        padding: ${theme.space[3]}px;
    }

    ${Button.Checkbox} {
        margin-${getDirection("left")}: auto;
    }

    @supports not (column-gap: 0) {
        ${Button.Checkbox} {
            margin-${getDirection("left")}: ${theme.space[2]}px;
        }
    }
`;

export const Wrapper = styled.div<{
    background?: boolean;
    selected?: boolean;
    isInSelectedPack?: boolean;
    hasClick?: boolean;
}>`
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: space-around;
    border-radius: 4px;

    ${({ background, selected, isInSelectedPack }) =>
        background &&
        css`
            background-color: ${theme.colors.primaryWhite};
            border-radius: 4px;
            box-shadow: ${selected || isInSelectedPack ? "none" : "0 0 8px rgba(0, 0, 0, 0.25)"};

            ${selected &&
            css`
                box-shadow: 0 0 0 2px ${theme.colors.primaryBlack};
            `};

            ${isInSelectedPack &&
            css`
                box-shadow: 0 0 0 2px ${theme.colors.grey3};
            `};

            ${ImageWrapper} {
                overflow: hidden;
            }
        `}

    ${({ background }) =>
        !background &&
        css`
            ${Header} {
                padding-left: 0;
                padding-right: 0;
            }
        `};
    ${({ hasClick }) =>
        !hasClick &&
        css`
            ${ImageWrapper}, ${Footer}, ${Header} {
                cursor: auto;
            }
        `};
`;

export const Name = styled.div`
    display: inline-block;
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-align: ${getDirection("left")};
    ${lineClampStyle};
    /* Override default lineclamp lines to 5 */
    -webkit-line-clamp: 5;
    line-clamp: 5;
`;

export const NameButton = styled.button`
    display: inline-block;
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-align: ${getDirection("left")};
    word-break: break-word;
    hyphens: auto;
`;

export const Description = styled.div`
    margin-${getDirection("left")}: ${theme.space[2]}px;
    text-align: start;
`;
